import { ClickEventType, GOI_WEB_URL, HStack, Spacing, customEvent } from "goi_common";

import { useRefundSangjoPrice } from "@/hooks/useRefundSangjoPrice";
import { useRefundCalculatorForm } from "@/hooks/useRefundCalculatorForm";
import { useRefundSangjoTotalPrice } from "@/hooks/useRefundSangjoTotalPrice";

import SANGJO_PRODUCTS from "@/constants/grouped_sangjo_products.json";
import OutlinedButton from "@/components/button/OutlinedButton";
import RoundButton from "@/components/button/RoundButton";

import RefundCalculatorResult from "./RefundCalculatorResult";
import { RefundCalculatorSangjoSelect } from "./RefundCalculatorSangjoSelect";
import { RefundCalculatorSangjoProductSelect } from "./RefundCalculatorSangjoProductSelect";
import { RefundCalculatorPaymentDateSelect } from "./RefundCalculatorPaymentDateSelect";

export type SangjoProduct = (typeof SANGJO_PRODUCTS)["1"];

const RefundCalculatorContainer = () => {
  return (
    <>
      <p className="body_14_m">
        상조 해지 시 예상 환급금을 안내 해드립니다. 가입하신 상조 및 상품, 납입 횟수를 입력해주세요.
      </p>
      <RefundCalculatorForm />
    </>
  );
};

export const RefundCalculatorForm = () => {
  const { refundCalculatorForm, resetRefundCalculatorForm, handleChange } = useRefundCalculatorForm(
    {
      defaultForm: {
        sangjoId: "",
        productId: "",
        paymentsCount: "",
      },
    },
  );

  const { productUserTotalPrice, productTotalPrice } = useRefundSangjoTotalPrice({
    sangjoId: refundCalculatorForm.sangjoId,
    sangjoProductId: Number(refundCalculatorForm.productId),
    paymentsCount: Number(refundCalculatorForm.paymentsCount),
  });

  const { 상조환급금, reset_상조환급금, chage_상조환급금 } = useRefundSangjoPrice({
    totalUserPaymentPrice: productUserTotalPrice?.toString(),
    totalProductPrice: productTotalPrice?.toString(),
    totalPaymentDates: refundCalculatorForm.paymentsCount,
  });

  const currentPageEvent: ClickEventType = {
    domain: "heysangjo",
    path: "refund_calc_sangjo",
  };

  return (
    <div>
      <Spacing gap={34} />
      <p css={{ padding: "0px 0px 15px 0px" }}>가입하신 상조 및 상품명을 입력해주세요.</p>
      <HStack gap={10}>
        <RefundCalculatorSangjoSelect
          id="sangjoId"
          label="상조명"
          sangjoId={refundCalculatorForm.sangjoId}
          onChange={handleChange}
        />

        <Spacing gap={34} />
        <RefundCalculatorSangjoProductSelect
          id="productId"
          label="상품명"
          sangjoId={refundCalculatorForm.sangjoId}
          sangjoProductId={refundCalculatorForm.productId}
          onChange={handleChange}
        />
      </HStack>

      <Spacing gap={27} />
      <p css={{ padding: "0px 0px 15px 0px" }}>납입금을 납입한 횟수를 입력해주세요.</p>
      <RefundCalculatorPaymentDateSelect
        id="paymentsCount"
        label="납입 횟수"
        sangjoId={refundCalculatorForm.sangjoId}
        sangjoProductId={refundCalculatorForm.productId}
        paymentsCount={refundCalculatorForm.paymentsCount}
        onChange={handleChange}
      />

      <Spacing gap={40} />

      <OutlinedButton
        className="subtitle_18_b"
        size="medium"
        fullWidth
        onClick={() => {
          customEvent({
            ...currentPageEvent,
            trigger_and_target: "calculate_refund_fee",
          });
          chage_상조환급금();
        }}
      >
        환급금 계산하기
      </OutlinedButton>

      {상조환급금 !== undefined && 상조환급금 > -1 ? (
        <>
          <RefundCalculatorResult price={상조환급금} />
          <HStack gap={26} justifyContent="space-evenly">
            <RoundButton
              {...roudedButtonStyleProps}
              onClick={() => {
                resetRefundCalculatorForm();
                reset_상조환급금();
              }}
            >
              다시 조회
            </RoundButton>

            <a
              href={`${GOI_WEB_URL}/guidebook/tip/etc/cancel-contract/`}
              css={{ width: "100%" }}
              onClick={() => {
                customEvent({
                  ...currentPageEvent,
                  trigger_and_target: "uv_guide_cancel_contract",
                });
              }}
            >
              <RoundButton {...roudedButtonStyleProps}>상조 해지 알아보기</RoundButton>
            </a>
          </HStack>
        </>
      ) : null}
    </div>
  );
};

const roudedButtonStyleProps = {
  className: "button_16_sb",
  css: { width: "100%", justifyContent: "center", alignItems: "center" },
};

export default RefundCalculatorContainer;
